module.exports = __webpack_public_path__ + "img/comdex-light.f639c3c2.svg";